// extracted by mini-css-extract-plugin
export default {"container":"PublicationCarousel_container__HJ0Sw","title":"PublicationCarousel_title__Zvh5t","font":"PublicationCarousel_font__LPzJB"};